
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { QueryParamProvider } from "use-query-params";
import { SnackbarProvider } from "notistack";
import { configure } from "mobx";

import { theme } from "./theme";
import {
	AuthenticatedApp,
	HubProvider,
} from "components";
import { FirestoreProvider } from "./hooks";
import SetStore from "./views/SetStore";
import DisplayApp from "./views/Rail";
import Error404Page from "./views/Error404.jsx";

// import 'react-perfect-scrollbar/dist/css/styles.css'
import "./assets/scss/main.scss";

configure({
	enforceActions: "never",
});

function App() {
	return (
		<FirestoreProvider>
			<HubProvider>
				<ThemeProvider theme={theme}>
					<SnackbarProvider maxSnack={3}>
						<Router>
							<QueryParamProvider ReactRouterRoute={Route}>
								<Switch>
									<Route exact component={SetStore} path="/set-store" />
									<AuthenticatedApp exact component={DisplayApp} path="/" />
									<Route component={Error404Page} />
								</Switch>
							</QueryParamProvider>
						</Router>
					</SnackbarProvider>
				</ThemeProvider>
			</HubProvider>
		</FirestoreProvider>
	);
}

export default App;
